
// logo app

export default function LogoApp({ className = '' }) {
    return (
        <img src="./CashFlowLogo.png" className={`w-[50px] ${className}`} alt="Cash Flow Logo" />
    )
}